import { call, put, fork, select } from 'redux-saga/effects'
import firebase from '../config/firebase'
import CartBasedPromotionActions from '../reducers/cartBasedPromotionReducer'

import utils from '../utils'

export function* getCartBasedPromotions() {
  const { region = utils.constants.REGION.PHNOM_PENH } = yield select(state => state.auth.data)

  const cartBasedPromotions = {}

  const dbRef = firebase
    .firestore()
    .collection('cart_based_promotions')
    .where('region', '==', region)

  try {
    yield put(CartBasedPromotionActions.setLoading(true))

    const querySnapshot = yield call([dbRef, dbRef.get])

    querySnapshot.forEach(cartBasedPromotion => {
      cartBasedPromotions[cartBasedPromotion.id] = { id: cartBasedPromotion.id, ...cartBasedPromotion.data() }
    })

    yield put(CartBasedPromotionActions.setCartBasedPromotions(cartBasedPromotions))
    yield put(CartBasedPromotionActions.setLoading(false))
  } catch (error) {
    yield put(CartBasedPromotionActions.setLoading(false))
    yield put(CartBasedPromotionActions.setCartBasedPromotions(cartBasedPromotions))
    alert(error)
  }
}

export function* saveCartBasedPromotion({ data, callBack }) {
  const { region = utils.constants.REGION.PHNOM_PENH } = yield select(state => state.auth.data)

  const cartBasedPromotionCollection = firebase.firestore().collection('cart_based_promotions')

  const cartBasedPromotionDoc = data.id
    ? cartBasedPromotionCollection.doc(data.id)
    : cartBasedPromotionCollection.doc()

  const { id } = cartBasedPromotionDoc

  data.id = id
  data.region = region
  data.restaurant = data.is_global ? '' : data.restaurant

  try {
    yield put(CartBasedPromotionActions.setSaving(true))
    yield call([cartBasedPromotionDoc, cartBasedPromotionDoc.set], data)
    yield put(CartBasedPromotionActions.setCartBasedPromotion(id, data))
    yield put(CartBasedPromotionActions.setSaving(false))
    yield call(callBack)
  } catch (e) {
    alert(e)
    yield put(CartBasedPromotionActions.setSaving(false))
  }
}

export function* deleteCartBasedPromotion({ id }) {
  const dbRef = firebase
    .firestore()
    .collection('cart_based_promotions')
    .doc(id)

  try {
    yield fork([dbRef, dbRef.delete])
  } catch (error) {
    alert(error)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/cartBasedPromotionSaga.js